


var catalog = {
    data: function () {
      return {
        addProduct: {},
      }
    },

    filters:{

        currency: function(value)
        {
            if (typeof value !== "number") {
                    return value;
                }
                var formatter = new Intl.NumberFormat('ru-Ru', {
                    style: 'currency',
                    currency: 'RUB',
                    maximumFractionDigits:0
                });
            
                return formatter.format(value);
        }
    },
    methods: {
        hello: function () {
          console.log('привет из примеси!')
        },
        
        sendRequest: function(params)
        {
          

        },

        

        addToBasket: function(item){

          let vue = this;
          let params = {entity: "product", 
                  action: "addProductBasket",
                  id_product: item.ID
              };

              $.ajax({
                type: "POST",
                url: "/local/ajaxHandler.php",
                data: params,
                dataType: "json",
                success: function (response) {
                    
                    if(response.status)
                    {
                        item.BASKET = true;
                        //console.log(vue);
                        vue.addProduct = item;
                        if ('addProductHandler' in vue)
                        {
                            vue.addProductHandler();
                        }
                        else
                        {
                            vue.$emit('add-product', item);
                        }

                        bus.$emit('add-product', 1);
                        window.BASKET_COUNT++;

                        vue.$ecommerce.addToCart({"id": item.ID,
                                                    "name": item.NAME,
                                                    "price": parseInt(item.PRICE),
                                                    "quantity": 1,
                                                    //"category": this.arResult.PATH[this.arResult.PATH.length - 2].NAME
                                            });
                        //console.log("add");
                    }
                }
            });
         

      },

      addToFavorite: function(item)
      {
          let params = {entity: "product", 
                  action: "addProductFavorite",
                  id_product: item.ID
              };


          $.ajax({
              type: "POST",
              url: "/local/ajaxHandler.php",
              data: params,
              dataType: "json",
              success: function (response) {
                  
                  if(response.status)
                  {
                      item.FAVORITE = true;
                      bus.$emit('add-favorite', 1);
                      console.log("Добавлен");
                  }
              }
          });
      },

      addProductCompare: function(item)
      {
          let params = {entity: "product", 
                  action: "addProductCompare",
                  id_product: item.ID
              };


          $.ajax({
              type: "POST",
              url: "/local/ajaxHandler.php",
              data: params,
              dataType: "json",
              success: function (response) {
                  
                  if(response.status)
                  {
                      item.COMPARE = true;
                      console.log("Добавлен");
                  }
              }
          });
        },

        getRating(star, item)
        {
            if(item.hasOwnProperty('RATING') && 
                star < parseInt(item.RATING) + 1)
            {
                return true;
            }
            else
            {
                return false;
            }
        },

        getCountFeed(item)
        {
            if(item.hasOwnProperty('BLOG_COMMENTS_CNT'))
            {
                return item.BLOG_COMMENTS_CNT;
            }
            else
            {
                return 0;
            }
        },
      }
  }

if(!window.mixins)
{
    window.mixins = {};
}

//window.mixins.catalog = catalog;
export default catalog;